import { RealStoreIntegrations } from '../../settings/RealStoreIntegrations'

export function SellerStoresPage() {
  return <RealStoreIntegrations />
}
